<form>
	<ui-modal [modalTitle]="id === 'new' ? 'New Labour Type' : 'Labour Type Details'" [scrollable]="true">
		<ng-container *ngIf="details">
			<ui-form labelWidth="12rem">
				<ui-form-control label="Labour type description">
					<input class="form-control" [(ngModel)]="details.description" (ngModelChange)="tutorialCheck()" [ngModelOptions]="{ standalone: true }" [appTutorial]="306" autocomplete="chrome-off" appAutoFocus>
				</ui-form-control>
				<ui-form-control label="Group">
					<select class="custom-select" [(ngModel)]="details.category_id" [ngModelOptions]="{ standalone: true }">
						<option *ngFor="let item of categories" [ngValue]="item.id">{{item.description}}</option>
					</select>
				</ui-form-control>
				<ui-form-control *ngIf="details.accounts_assignment" label="Sales Account Assignment">
					<div class="d-flex">
						<input type="text" class="form-control" [ngModel]="details.accounts_assignment.id ? details.accounts_assignment.name : 'Not selected'" [ngModelOptions]="{ standalone: true }" readonly>
						<button *ngIf="details.accounts_assignment.id" type="button" class="btn btn-outline-secondary p-2 ml-1" (click)="details.accounts_assignment.id = null"><i class="wq wq-close"></i></button>
						<button type="button" class="btn btn-outline-secondary p-2 ml-1" (click)="selectAssignment('sales')"><i class="wq wq-search"></i></button>
					</div>
				</ui-form-control>
				<ui-form-control *ngIf="details.po_accounts_assignment" label="PO Account Assignment">
					<div class="d-flex">
						<input type="text" class="form-control" [ngModel]="details.po_accounts_assignment.id ? details.po_accounts_assignment.name : 'Not selected'" [ngModelOptions]="{ standalone: true }" readonly>
						<button *ngIf="details.po_accounts_assignment.id" type="button" class="btn btn-outline-secondary p-2 ml-1" (click)="details.po_accounts_assignment.id = null"><i class="wq wq-close"></i></button>
						<button type="button" class="btn btn-outline-secondary p-2 ml-1" (click)="selectAssignment('po')"><i class="wq wq-search"></i></button>
					</div>
				</ui-form-control>
			</ui-form>

			<hr>

			<ng-template #priceForm let-priceRecord>
				<ui-form labelWidth="12rem">
					<ui-form-control>
						<div class="d-flex">
							<div class="col-form-label text-center flex-weight-1 mr-3">Hourly Rate</div>
							<div class="col-form-label text-center flex-weight-1">Day Rate</div>
						</div>
					</ui-form-control>
					<ng-container *ngIf="app.orgInfo?.role.can_see_costs">
						<ui-form-control label="Cost">
							<div class="d-flex">
								<input class="form-control flex-weight-1 text-right text-bold mr-3" [(ngModel)]="priceRecord.hourly_cost" [ngModelOptions]="{ standalone: true }" (input)="recalculate('cost', priceRecord)" (change)="recalculate()" autocomplete="chrome-off">
								<input class="form-control flex-weight-1 text-right" [ngClass]="{ invisible: zeroHours }" [(ngModel)]="priceRecord.dayCost" [ngModelOptions]="{ standalone: true }" (input)="recalculate('dayCost', priceRecord)" (change)="recalculate()" autocomplete="chrome-off">
							</div>
						</ui-form-control>
						<ui-form-control label="Markup %">
							<div class="d-flex">
								<input class="form-control flex-weight-1 text-right mr-3" [(ngModel)]="priceRecord.markup" [ngModelOptions]="{ standalone: true }" (input)="recalculate('markup', priceRecord)" (change)="recalculate()" autocomplete="chrome-off">
								<div class="form-control flex-weight-1 invisible"></div>
							</div>
						</ui-form-control>
						<ui-form-control label="Margin %">
							<div class="d-flex">
								<input class="form-control flex-weight-1 text-right mr-3" [(ngModel)]="priceRecord.margin" [ngModelOptions]="{ standalone: true }" (input)="recalculate('margin', priceRecord)" (change)="recalculate()" autocomplete="chrome-off">
								<div class="form-control flex-weight-1 invisible"></div>
							</div>
						</ui-form-control>
					</ng-container>
					<ui-form-control label="Price">
						<div class="d-flex">
							<input class="form-control flex-weight-1 text-right text-bold mr-3" [(ngModel)]="priceRecord.hourly_price" [ngModelOptions]="{ standalone: true }" (input)="recalculate('price', priceRecord)" (change)="recalculate()" autocomplete="chrome-off">
							<input class="form-control flex-weight-1 text-right" [ngClass]="{ invisible: zeroHours }" [(ngModel)]="priceRecord.dayPrice" [ngModelOptions]="{ standalone: true }" (input)="recalculate('dayPrice', priceRecord)" (change)="recalculate()" autocomplete="chrome-off">
						</div>
					</ui-form-control>
					<ui-form-control *ngIf="app.orgInfo?.role.can_see_costs" label="Profit">
						<div class="d-flex">
							<input class="form-control flex-weight-1 text-right mr-3" [(ngModel)]="priceRecord.profit" [ngModelOptions]="{ standalone: true }" (input)="recalculate('profit', priceRecord)" (change)="recalculate()" autocomplete="chrome-off">
							<input class="form-control flex-weight-1 text-right" [ngClass]="{ invisible: zeroHours }" [(ngModel)]="priceRecord.dayProfit" [ngModelOptions]="{ standalone: true }" (input)="recalculate('dayProfit', priceRecord)" (change)="recalculate()" autocomplete="chrome-off">
						</div>
					</ui-form-control>
				</ui-form>
			</ng-template>

			<div class="m-n2 p-2" [appTutorial]="307">
				<div class="pb-3" [ngClass]="{ 'border border-lightgrey rounded px-3 mb-3': aliases?.length || multiCurrency }">
					<div *ngIf="aliases?.length || multiCurrency" class="d-flex flex-column mx-n3 mb-2 bg-light">
						<div *ngIf="aliases?.length" class="text-bold px-2 py-1" [ngClass]="{ 'border-bottom': !multiCurrency }">{{companyName}} (default)</div>
						<div *ngIf="multiCurrency" class="d-flex">
							<div *ngFor="let pp of details.prices; let index = index" class="px-3 py-2 selectable hoverable border-bottom d-flex align-items-center" [ngClass]="{ 'border-primary border-4': pp === selectedPrice, 'border-lightgrey': pp !== selectedPrice }" (click)="selectedPrice = pp">
								<span class="text-uppercase text-small text-bold" [ngClass]="{ 'text-secondary': pp !== selectedPrice && index > 0, 'text-primary': index === 0 }">{{pp.currency_id}}</span>
							</div>
							<div class="border-bottom d-flex align-items-center px-2">
								<ng-container *ngIf="currenciesNotAdded(); let clist">
									<ng-container *ngIf="clist.length">
										<div class="dropdown d-inline-block">
											<button type="button" class="btn btn-outline-success p-1 dropdown-toggle" data-toggle="dropdown" ngbTooltip="Add currency"><i class="wq wq-add"></i></button>
											<div class="dropdown-menu">
												<button *ngFor="let c of clist" type="button" class="dropdown-item dropdown-item-success" (click)="addCurrency(c)">{{c}}</button>
											</div>
										</div>
									</ng-container>
								</ng-container>
							</div>
							<div class="border-bottom flex-weight-1"></div>
							<ng-container *ngIf="!isPrimaryPrice()">
								<div class="border-bottom d-flex align-items-center">
									<button type="button" class="btn btn-outline-primary p-1" ngbTooltip="Set as primary currency for this labour type" (click)="setPrimaryPrice()"><i class="wq wq-arrow-left"></i></button>
								</div>
								<div class="border-bottom d-flex align-items-center px-2">
									<button type="button" class="btn btn-outline-danger p-1" ngbTooltip="Remove this currency" (click)="removePrice()"><i class="wq wq-delete"></i></button>
								</div>
							</ng-container>
						</div>
					</div>

					<ng-container *ngTemplateOutlet="priceForm;context:{$implicit:selectedPrice}"></ng-container>
				</div>

				<ng-container *ngIf="aliasesAdded(); let alist">
					<div *ngFor="let alias of alist" class="pb-3" [ngClass]="{ 'border border-lightgrey rounded px-3 mb-3': aliases?.length || multiCurrency }">
						<div *ngIf="aliases?.length || multiCurrency" class="d-flex flex-column mx-n3 mb-2 bg-light">
							<div *ngIf="aliases?.length" class="text-bold px-2 py-1 d-flex align-items-center" [ngClass]="{ 'border-bottom': !multiCurrency }">
								<div>{{alias.company_name}}</div>
								<div class="flex-weight-1"></div>
								<div>
									<button type="button" class="btn btn-outline-secondary border-0 p-1" (click)="deleteAlias(alias)"><i class="wq wq-delete mr-2"></i>Remove company</button>
								</div>
							</div>
							<div *ngIf="multiCurrency" class="d-flex">
								<div *ngFor="let pp of details.prices; let index = index" class="px-3 py-2 selectable hoverable border-bottom d-flex align-items-center" [ngClass]="{ 'border-primary border-4': pp === selectedPrice, 'border-lightgrey': pp !== selectedPrice }" (click)="selectedPrice = pp">
									<span class="text-uppercase text-small text-bold" [ngClass]="{ 'text-secondary': pp !== selectedPrice && index > 0, 'text-primary': index === 0 }">{{pp.currency_id}}</span>
								</div>
								<div class="border-bottom flex-weight-1"></div>
							</div>
						</div>

						<ng-container *ngFor="let ap of details?.alias_prices">
							<ng-container *ngIf="ap.alias_id === alias.id && ap.currency_id === selectedPrice?.currency_id">
								<ng-container *ngTemplateOutlet="priceForm;context:{$implicit:ap}"></ng-container>
							</ng-container>
						</ng-container>
					</div>
				</ng-container>

				<ng-container *ngIf="aliasesNotAdded(); let alist">
					<div *ngIf="alist.length" class="dropdown d-inline-block">
						<button type="button" class="btn btn-outline-success btn-sm dropdown-toggle" data-toggle="dropdown"><i class="wq wq-add mr-2"></i>Add secondary company price</button>
						<div class="dropdown-menu">
							<button *ngFor="let a of alist" type="button" class="dropdown-item dropdown-item-success" (click)="addAlias(a)">{{a.company_name}}</button>
						</div>
					</div>
				</ng-container>

				<hr>

				<ui-form labelWidth="12rem">
					<ui-form-control label="Hours per day">
						<div class="d-flex">
							<div class="form-control flex-weight-1 mr-3 invisible"></div>
							<input class="form-control flex-weight-1 text-right" [(ngModel)]="details.hours_per_day" [ngModelOptions]="{ standalone: true }" (input)="recalculate('hours_per_day')" (change)="recalculate()" autocomplete="chrome-off">
						</div>
					</ui-form-control>
					<ui-form-control *ngIf="app.orgInfo?.allow_sales_management" label="Sales multiplier">
						<div class="d-flex">
							<div class="form-control flex-weight-1 mr-3 invisible"></div>
							<input class="form-control flex-weight-1 text-right" [(ngModel)]="details.sales_multiplier" [ngModelOptions]="{ standalone: true }" (change)="recalculate()" autocomplete="chrome-off">
						</div>
					</ui-form-control>
				</ui-form>

				<hr>

				<label class="custom-control custom-checkbox mt-2">
					<input type="checkbox" class="custom-control-input" [ngModel]="!!details.use_product_vat" (ngModelChange)="details.use_product_vat = $event ? 1 : 0" [ngModelOptions]="{ standalone: true }">
					<span class="custom-control-label">Use product's {{app.translatedVATTerm}} rate</span>
				</label>

				<div *ngIf="!details.use_product_vat" class="alert alert-info mb-0">This labour type will use the <b>labour {{app.translatedVATTerm}} rate</b> that's set on the quote line. Usually used on labour that is not closely linked to the installation of a product, and therefore not eligible for reduced {{app.translatedVATTerm}}.</div>

				<div *ngIf="details.use_product_vat" class="alert alert-info mb-0">This labour type will use the <b>product's {{app.translatedVATTerm}} rate</b> that's set on the quote line. Usually used on labour that is closely linked to the installation of a product, and therefore eligible for reduced {{app.translatedVATTerm}}.</div>

				<hr>

				<label class="custom-control custom-checkbox mt-2">
					<input type="checkbox" class="custom-control-input" [ngModel]="!!details.labour_for_subcontractor" (ngModelChange)="details.labour_for_subcontractor = $event ? 1 : 0" [ngModelOptions]="{ standalone: true }">
					<span class="custom-control-label">Labour for subcontractor</span>
				</label>
				<div class="text-info"><i class="wq wq-info mr-1"></i>Check this to include labour on purchase orders.</div>

			</div>
		</ng-container>

		<button *ngIf="canDelete" type="button" class="btn btn-danger" (click)="deleteLabour()" [disabled]="disabled" ui-modal-footer>Delete</button>
		<button *ngIf="canArchive" type="button" class="btn btn-danger" (click)="archiveLabour()" [disabled]="disabled" ui-modal-footer>Delete</button>
		<button *ngIf="canUnarchive" type="button" class="btn btn-danger" (click)="unarchiveLabour()" [disabled]="disabled" ui-modal-footer>Restore</button>
		<div class="flex-weight-1" ui-modal-footer></div>
		<button type="button" class="btn btn-medium" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button type="submit" class="btn btn-primary" (click)="save()" [disabled]="disabled" [appTutorial]="305" ui-modal-footer>Save</button>
	</ui-modal>
</form>

<app-integration-accounts-select-assignment-modal (close)="selectAssignmentModalClosed($event)"></app-integration-accounts-select-assignment-modal>

<modal-replace-labour (close)="replaceLabourModalClosed($event)"></modal-replace-labour>
